import { ZomentumRoutes } from "@/Contracts";
import { AllRolePermissions } from "@/Contracts/Users";
import { EIcons } from "@atoms/ZIcon/interface";
import { ILeftMenuItem } from "./interface";
import { isDashboardAllowedForPartner } from "@/Components/Utils";
import { useFeatureFlag } from "@/Hooks";

export default (pathname: string): Array<ILeftMenuItem> => {
	const leftMenuItems: Array<ILeftMenuItem> = [
		{
			route: ZomentumRoutes.OpportunityList,
			selected: pathname.includes(ZomentumRoutes.OpportunityList),
			title: "Opportunities",
			icon: EIcons.OPPORTUNITIES,
			permission: AllRolePermissions.OPPORTUNITY_READ
		},
		{
			route: ZomentumRoutes.DocumentsList,
			selected:
				pathname.includes(ZomentumRoutes.DocumentsList) ||
				pathname.includes(ZomentumRoutes.TemplatesList) ||
				pathname.includes(ZomentumRoutes.Assessments),
			title: "Documents",
			icon: EIcons.FILE,
			permission: AllRolePermissions.DOCUMENT_READ
		},
		{
			route: ZomentumRoutes.ClientsList,
			selected: pathname.includes(ZomentumRoutes.ClientsList),
			title: "Clients",
			icon: EIcons.USERS,
			permission: AllRolePermissions.CLIENT_COMPANY_READ
		},
		{
			route: ZomentumRoutes.ProductsList,
			selected:
				pathname.includes(ZomentumRoutes.ProductsList) &&
				!pathname.includes(ZomentumRoutes.Marketplace),
			title: "Products",
			icon: EIcons.PACKAGE,
			permission: AllRolePermissions.ITEM_READ
		},
		{
			route: ZomentumRoutes.ReportsList,
			selected:
				pathname.includes(ZomentumRoutes.ReportsList) ||
				pathname.includes(ZomentumRoutes.CreateReport),
			title: "Reports",
			icon: EIcons.CHARTPIE,
			permission: AllRolePermissions.REPORT_READ
		},
		{
			route: ZomentumRoutes.SalesActivityAutomationsList,
			selected: pathname.includes(
				ZomentumRoutes.SalesActivityAutomationsList
			),
			title: "Sales Automation",
			icon: EIcons.NETWORK,
			permission: AllRolePermissions.SALES_AUTOMATION_READ
		},
		{
			route: ZomentumRoutes.Settings,
			selected: pathname.includes(ZomentumRoutes.Settings),
			title: "Settings",
			icon: EIcons.SETTING,
			permission: null
		}
	];

	const showSalesActivity = useFeatureFlag("show_sales_activity");
	if (showSalesActivity) {
		leftMenuItems.splice(2, 0, {
			route: ZomentumRoutes.SalesActivityPage,
			selected: pathname.includes(ZomentumRoutes.SalesActivityPage),
			title: "Sales Activity",
			icon: EIcons.SALESACTIVITY,
			permission: AllRolePermissions.SALES_ACTIVITY_READ
		});
	}

	const showPartnerAlignFeaturesFlag = useFeatureFlag(
		"show_partner_align_features"
	);
	const isPartnerDashboardAllowed = isDashboardAllowedForPartner();
	isPartnerDashboardAllowed &&
		showPartnerAlignFeaturesFlag &&
		leftMenuItems.splice(0, 0, {
			route: ZomentumRoutes.PartnerDashboard,
			selected: pathname.includes(ZomentumRoutes.PartnerDashboard)
				? true
				: false,
			title: "Dashboard",
			icon: EIcons.VENDORHOME,
			permission: null
		});
	if (showPartnerAlignFeaturesFlag) {
		leftMenuItems.splice(leftMenuItems.length - 1, 0, {
			route: ZomentumRoutes.Marketplace,
			title: "Align",
			selected: `${window.location.href}`.includes(
				`${window.location.origin}${ZomentumRoutes.Marketplace}`
			),
			icon: EIcons.MARKETPLACE,
			permission: null
		});
	}
	return leftMenuItems;
};
